import { Edit01Icon, PlusIcon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { Button } from '@/design-system/components/Button';

import { BaseProps, DatasetCrudPane } from './DatasetCrudPane';

export const DatasetCrudPaneWithButton = ({
  dataset,
  dataType,
  asLink,
  onSuccess,
  color,
  variant,
  prefilledData,
  preselectedRuns,
  baseDatasetOnRunType,
  ...props
}: BaseProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonColor = color ?? (dataset ? 'primary' : undefined);
  const label = dataset ? 'Edit' : 'New Dataset';
  return (
    <>
      <Button
        size="md"
        color={buttonColor}
        leftDecorator={dataset ? Edit01Icon : PlusIcon}
        onClick={() => {
          setIsOpen(true);
        }}
        {...props}
        variant={variant ?? asLink ? 'underlined' : 'normal'}
      >
        {label}
      </Button>
      <DatasetCrudPane
        dataset={dataset}
        dataType={dataType}
        onSuccess={onSuccess}
        onCancel={() => setIsOpen(false)}
        label={label}
        open={isOpen}
        prefilledData={prefilledData}
        preselectedRunIds={preselectedRuns?.map((run) => run.id)}
        baseDatasetOnRunType={baseDatasetOnRunType}
      />
    </>
  );
};
